import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
const isObject = require('lodash/isObject');

const verUtil = require('../util/version.js');
const PermissionsUtil = require('../../../app/shared/PermissionsUtil');
import Navigator from '../Navigator';
const VoiceStore = require('../stores/VoiceStore');
const ChatbotSystem = require('../util/ChatbotSystem');
const ActivityStore = require('../stores/activity_store_reflux');
import TopNav from './DashboardNew/Menu/TopNav';
import HelpDropdown from './nav/HelpDropdown';
import Tooltip from './common/Tooltip';
import AccessibleIcon from './common/AccessibleIcon';
import IFrame from './IFrame';
import { PreviewView } from './PreviewActivityEditorReviewView';
import WarningBox from './common/WarningBox';
import WithActivityData from './DataHOCs/WithActivityData';
import WithTemplateData from './DataHOCs/WithTemplateData';
import WithChannelData from './DataHOCs/WithChannelData';
import WithProjectData from './DataHOCs/WithProjectData';
import WithDocumentVisible from './DataHOCs/WithDocumentVisible';
import WithActivityEditAccessData from './DataHOCs/WithActivityEditAccessData';

const propTypes = {
    history: PropTypes.object.isRequired,
    activityId: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    channelId: PropTypes.string.isRequired,
    activityVersion: PropTypes.string,
    activityStoreState: PropTypes.shape({ activity: PropTypes.object.isRequired }).isRequired,
    projectStoreState: PropTypes.shape({ project: PropTypes.shape({ user_permissions: PropTypes.object.isRequired}).isRequired }).isRequired,
    channelStoreState: PropTypes.shape({ channel: PropTypes.shape({ user_permissions: PropTypes.object.isRequired}).isRequired }).isRequired,
    templateStoreState: PropTypes.shape({
        template: PropTypes.shape({
            template_url: PropTypes.string.isRequired,
            editor_url: PropTypes.string.isRequired,
        }).isRequired
    }).isRequired,
};

const defaultProps = {
    activityVersion: '',
};

class ReviewActivityView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            mode: 'EDIT',
            clientFeatures: {
                user_data: false,
            },
            previewFrom: '',
            previewVersion: null,
            editingVersion: null,
        };

        this.iframe = React.createRef();
        this._handleEditorMessages = this._handleEditorMessages.bind(this);
        this.onClientFeatures = this.onClientFeatures.bind(this);
        this.sendUserData = this.sendUserData.bind(this);
        this.goBack = this.goBack.bind(this);
        this.gotoPreview = this.gotoPreview.bind(this);
        this.gotoPreviewCurrent = this.gotoPreviewCurrent.bind(this);
        this.gotoPreviewVersion = this.gotoPreviewVersion.bind(this);
        this.gotoEdit = this.gotoEdit.bind(this);
        this.getEditingVersion = this.getEditingVersion.bind(this);

        this.unsubscribes = [];
        const userData = {...props.activityEditAccessInfo, 
            activityId: props.activityId ? Number(props.activityId) : null,
            channelId: props.channelId ? Number(props.channelId) : null,
        }
        this.voiceSystem = VoiceStore.getVoiceSystem(VoiceStore.SYSTEM_USAGE.ACTIVITY_PREVIEW,{userData});
        this.chatbotSystem = new ChatbotSystem({userData, usage: ChatbotSystem.SYSTEM_USAGE.ACTIVITY_PREVIEW});
    }

    UNSAFE_componentWillMount() {
        if (!PermissionsUtil.canReviewActivity(this.props.channelStoreState.channel.user_permissions, this.props.projectStoreState.project.user_permissions)) {
            this.goBack();
        }
    }

    componentDidMount() {
        $(window).off('message', this._handleEditorMessages).on('message', this._handleEditorMessages);
    }

    componentWillUnmount() {
        $(window).off('message', this._handleEditorMessages);
        this.unsubscribes.forEach(u => u());
        if (this.voiceSystem) {
            this.voiceSystem.shutDown();
        }
        if (this.chatbotSystem) {
            this.chatbotSystem.shutDown();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.activityEditAccessInfo.access_key !== this.props.activityEditAccessInfo.access_key) {
            this.sendUserData();
        }
    }

    _handleEditorMessages(e) {
        const msg = e.originalEvent.data;
        const origin = e.originalEvent.origin;
        console.debug('REVIEW _handleEditorMessages', origin, msg);

        if (!GlobalConfig.DevMode && origin.indexOf('muzzylane.com') === -1) {
            return;
        }

        if (isObject(msg)) {
            if (this.chatbotSystem) {
                const targetWindow = this.iframe && this.iframe.current && this.iframe.current.contentWindow;
                let handled = this.chatbotSystem.handleMessage(msg,targetWindow);
                if (handled) {
                    return;
                }
            }
            if (this.voiceSystem) {
                const targetWindow = this.iframe && this.iframe.current && this.iframe.current.contentWindow;
                let handled = this.voiceSystem.handleMessage(msg,targetWindow);
                if (handled) {
                    return;
                }
            }
            switch (msg.type) {
                case 'features': { // client telling forge what it can do
                    this.onClientFeatures(msg.features);
                    break;
                }
                case "request-user-data": {
                    this.sendUserData();
                    break;
                }
                case "preview-from": {
                    this.setState({ previewFrom: msg.location });
                    break;
                }
            }
        }
        else {
            console.warn('Received deprecated old-style save API. Ignoring.');
        }
    }

    onClientFeatures(features) {
        const self = this;
        this.setState({ clientFeatures: features }, () => {
            self.sendUserData();
        });
    }

    sendUserData() {
        if (this.state.clientFeatures.user_data) {
            const iframe = this.iframe.current;
            if (!!iframe) {
                iframe.contentWindow.postMessage({ type: 'user-data', user_data: this.props.activityEditAccessInfo }, '*');
            }

            const comment = ActivityStore.getAndClearEditGotoComment(this.props.activityId);
            if (comment && this.state.clientFeatures.goto_comment && !!iframe) {
                iframe.contentWindow.postMessage({ type: 'goto-comment', id: comment.id, location: comment.location }, '*');
            }

        }
    }

    goBack() {
        this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/activity/${this.props.activityId}`);
    }

    gotoPreview() {
        const editingVersion = this.getEditingVersion();
        if (editingVersion && !verUtil.parseVersion(editingVersion).isAutosave()) {
            this.gotoPreviewVersion(editingVersion);
        }
        else {
            this.gotoPreviewCurrent();
        }
    }

    gotoPreviewCurrent() {
        $(window).off('message', this._handleEditorMessages);
        this.setState({ mode: 'PREVIEW', previewVersion: null });
    }

    gotoPreviewVersion(version) {
        $(window).off('message', this._handleEditorMessages);
        this.setState({ mode: 'PREVIEW', previewVersion: version });
    }

    gotoEdit() {
        $(window).off('message', this._handleEditorMessages).on('message', this._handleEditorMessages);
        this.setState({ mode: 'EDIT', previewVersion: null, editingVersion: this.state.previewVersion });
    }

    getEditingVersion() {
        const editingVersion = this.props.activityVersion || this.state.editingVersion || null;
        return editingVersion;
    }    

    render() {
        let mainContent;
        let editButtonText = 'Review';
        let editingVersion = null;
        const _activity = this.props.activityStoreState.activity;
        const _template = this.props.templateStoreState.template;

        if (this.state.mode === 'EDIT') {
            let reviewEditUrl = `${_template.editor_url}/edit/web/${_activity.activity_id}?review=1`;
            editingVersion = this.getEditingVersion();
            if (editingVersion) {
                reviewEditUrl += `/${editingVersion}`;
            }

            mainContent = <IFrame ref={this.iframe} url={reviewEditUrl} />;
        }
        else if (this.state.mode === 'PREVIEW') {
            if (this.state.previewVersion) {
                editButtonText += ` v${this.state.previewVersion}`;
            }

            mainContent = (
                <PreviewView
                    activityVersion={this.state.previewVersion}
                    previewFrom={this.state.previewFrom}
                    activityStoreState={this.props.activityStoreState}
                    templateStoreState={this.props.templateStoreState}
                    activityEditAccessInfo={this.props.activityEditAccessInfo}
                />
            );
        }
        else {
            mainContent = (
               <div className="mzlIFrame--other">
                    <WarningBox>
                        Invalid editor mode: "{this.state.mode}"
                    </WarningBox>
                </div>
            );
        }

        return (
            <div className="edit-activity">
                <TopNav onClickBrandLogo={Navigator.goToDashboardAuthorAuthoringChannelView.bind(this, this.props.history, this.props.channelId)}>
                    <HelpDropdown />
                    {(this.state.mode === 'EDIT') &&
                        <Button variant="light" className="editorButton margin-right-md" onClick={this.goBack}>Close</Button>
                    }
                    {(this.state.mode === 'EDIT' &&
                        PermissionsUtil.canPreviewActivity(this.props.channelStoreState.channel.user_permissions, this.props.projectStoreState.project.user_permissions)
                    ) &&
                        <Tooltip
                            id="prev-ed-tt"
                            className="font-size-14px margin-right-md"
                            placement="bottom"
                            triggerElem={(
                                <div style={{display: 'inline-block', padding: '7px'}}>{/* padding necessary to get disabled tooltip to work*/}
                                    <Button
                                        variant="light"
                                        className="editorButton"
                                        onClick={this.gotoPreview}
                                    >
                                        Preview
                                        {(!!this.state.previewFrom) &&
                                            <AccessibleIcon className="fa fa-play-circle-o margin-left-sm" label="from location" />
                                        }
                                    </Button>
                                </div>
                            )}
                        >
                        {(!!editingVersion) ? 
                            "Preview version " + editingVersion + " of this activity as a student"
                            :
                            "Preview the current version of this activity as a student"
                        }
                        </Tooltip>
                    }
                    {(this.state.mode === 'EDIT') &&
                        <Button variant="light" className="editorButton" disabled>
                            Review Mode (Read-Only)
                        </Button>
                    }
                    {(this.state.mode === 'PREVIEW') &&
                        <Button variant="light" className="editorButton" onClick={this.gotoEdit}>{editButtonText}</Button>
                    }
                </TopNav>
                {mainContent}
            </div>
        );
    }
}

ReviewActivityView.propTypes = propTypes;
ReviewActivityView.defaultProps = defaultProps;

const WrappedComponent = withRouter(WithDocumentVisible(WithActivityData(WithTemplateData(WithChannelData(WithProjectData(WithActivityEditAccessData(ReviewActivityView)))))));

// WithActivityData is expected the activityId prop. "Rename" props.params.activityID to props.activityId here. do the same with projectId, channelId & activityVersion
function WrappedComponentWithUpdatedPropNames(props) {
    return (
        <WrappedComponent
            {...props}
            activityId={props.match.params.activityId}
            projectId={props.match.params.projectId}
            channelId={props.match.params.channelId}
            activityVersion={props.match.params.activityVersion}
        />
    );
}

WrappedComponentWithUpdatedPropNames.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            channelId: PropTypes.string.isRequired,
            projectId: PropTypes.string.isRequired,
            activityId: PropTypes.string.isRequired,
            activityVersion: PropTypes.string
        }).isRequired,
    }).isRequired,
};

export default WrappedComponentWithUpdatedPropNames;